export const visit = (vm, at) => {
at({ "es-mx": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Lo sentimos. No pudimos verificar tu direcci\xF3n de correo." } } } });
};